import { apiRequest, API_ENDPOINTS } from '../config/api';

export interface FitnessFunctionDefinition {
  kind?: string;
  template?: string;
  params?: Record<string, unknown>;
  [key: string]: unknown;
}

export interface FitnessFunction {
  id: string;
  project_id?: string;
  name: string;
  description?: string;
  definition: FitnessFunctionDefinition;
  enabled?: boolean;
  created_by?: string;
  created_at?: string;
  updated_at?: string;
  [key: string]: unknown;
}

export interface FitnessFunctionPayload {
  name?: string;
  description?: string;
  definition?: FitnessFunctionDefinition;
  enabled?: boolean;
  [key: string]: unknown;
}

export const listFitnessFunctions = (projectId: string): Promise<FitnessFunction[]> =>
  apiRequest(API_ENDPOINTS.fitnessFunctions.list(projectId), { method: 'GET' });

export const createFitnessFunction = (
  projectId: string,
  payload: FitnessFunctionPayload,
): Promise<FitnessFunction> =>
  apiRequest(API_ENDPOINTS.fitnessFunctions.create(projectId), {
    method: 'POST',
    body: JSON.stringify(payload),
  });

export const updateFitnessFunction = (
  projectId: string,
  id: string,
  payload: FitnessFunctionPayload,
): Promise<FitnessFunction> =>
  apiRequest(API_ENDPOINTS.fitnessFunctions.update(projectId, id), {
    method: 'PUT',
    body: JSON.stringify(payload),
  });

export const deleteFitnessFunction = (projectId: string, id: string): Promise<void> =>
  apiRequest(API_ENDPOINTS.fitnessFunctions.delete(projectId, id), { method: 'DELETE' });
